import(/* webpackMode: "eager" */ "/app/src/app/[festival-slug]/[locale]/(rest)/films/loading.tsx");
